import Login from "./components/auth/login/Login";
import Register from "./components/auth/register/Register";
import { useRoutes } from "react-router-dom";
import ReportPage from "./page/ReportPage";
import JobConfigPage from "./page/JobConfigPage";
import { Layout } from 'antd';
import { AuthProvider, useAuth } from "./contexts/authContext";
import MyHeader from "./components/header/MyHeader";
import OnboardingPage from "./page/OnboardingPage";
import { CustomerServiceOutlined } from '@ant-design/icons'; // Import antd icon
import './App.css';
import ProtectedRoute from "./components/routes/ProtectedRoute";
import CheckoutForm from "./page/CheckoutForm";
import {Elements} from "@stripe/react-stripe-js";
import {stripePromise} from "./stripe";
import BalancePage from "./page/BalancePage"; // Add some styling for the floating icon

const { Content} = Layout;

function App() {
  const { currentUser } = useAuth();

  const routesArray = [
    {
      path: "*",
      element: <Login />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/register",
      element: <Register />,
    },
    {
      path: "/checkout",
      element: (<Elements stripe={stripePromise}>
        <CheckoutForm />
      </Elements>),
    },
    {
      path: "/onboarding",
      element: (<ProtectedRoute>
        <OnboardingPage />
      </ProtectedRoute>),
    },
    {
      path: "/report",
      element: (<ProtectedRoute>
        <ReportPage />
      </ProtectedRoute>),
    },
    {
      path: "/balance",
      element: (<ProtectedRoute>
        <BalancePage />
      </ProtectedRoute>),
    },
    {
      path: "/job-config",
      element: (<ProtectedRoute><JobConfigPage /></ProtectedRoute>),
    },
    {
      path: "/job-config/:tabKey", // Dynamic route for tab selection
      element: (<ProtectedRoute>
        <JobConfigPage />
      </ProtectedRoute>),
    },
  ];

  let routesElement = useRoutes(routesArray);

  const supportMessage = `https://t.me/cvpostman_support?text=Доброго дня, мій емейл на DOU Bidder ${currentUser?.email || ""}. Я маю наступне питання: `;

  return (
      <AuthProvider>
        <Layout>
          <MyHeader />
          <Content style={{ height: '100vh', backgroundColor: 'white' }}>
            {routesElement}
          </Content>

          {/* Customer Support Floating Button */}
          <a
              href={supportMessage}
              target="_blank"
              rel="noopener noreferrer"
              className="floating-support-icon"
              title="Підтримка"
          >
            <CustomerServiceOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
          </a>
        </Layout>
      </AuthProvider>
  );
}

export default App;
